import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { BannerInline } from "../../bannerInline/BannerInline";
import { getRoamingDevicesLimits } from "../../../store/devices";
import { isSpsonMaxLimitWarningVisible } from "../../../store/banners";
import { hideSpsonMaxLimitWarning } from "../../../store/banners";
import { useIntlTranslate } from "../../../hooks";

import "./RoamingLimitWarning.scss";

export const RoamingLimitWarning = () => {
  const dispatch = useDispatch();
  const translate = useIntlTranslate();

  const isWarningVisible = useSelector(isSpsonMaxLimitWarningVisible);
  const {
    isRoamingLimitReached,
    roamingDevicesCount,
    roamingDevicesLimit,
    isRoamingLimitApproaching,
  } = useSelector(getRoamingDevicesLimits);

  const handleClick = () => dispatch(hideSpsonMaxLimitWarning());

  if (
    (!isRoamingLimitApproaching && !isRoamingLimitReached) ||
    !isWarningVisible
  ) {
    return null;
  }

  const reachingLimitMessage = translate("roaming_reaching_limit_info", {
    b: (chunks) => <span className="strong">{chunks}</span>,
    roamingDevicesCount,
    roamingDevicesLimit,
  });

  const limitReachedMessage = translate("roaming_reached_limit_info", {
    b: (chunks) => <span className="strong">{chunks}</span>,
    roamingDevicesCount,
    roamingDevicesLimit,
  });

  const message = isRoamingLimitReached
    ? limitReachedMessage
    : reachingLimitMessage;

  return (
    <BannerInline
      onClick={handleClick}
      className={"roaming-limit-warning"}
      message={message}
    />
  );
};
